import { DefaultError, useQueryClient } from '@tanstack/react-query';
import { Form } from 'components/organisms';
import { settingsInitialValues } from 'components/organisms/forms/settings/ApplicationSettingsForm';
import i18n from 'locales/i18n';
import middleware from 'middleware';
import { useStoreState } from 'providers/StoreStateContext';
import { useEffect } from 'react';
import {
  useAppSettings,
  useUpdateAppSettings,
} from 'services/settings/application/Application';
import { ISettingsForm } from 'services/settings/application/types';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const Application = () => {
  const queryClient = useQueryClient();
  const { applicationSettings, setApplicationSettings } = useStoreState();

  const getAppSettings = useAppSettings();

  const updateSettings = useUpdateAppSettings();

  const onSubmit = async (values: ISettingsForm) => {
    await updateSettings.mutateAsync(values, {
      onSuccess: async data => {
        await getAppSettings.refetch();
        setApplicationSettings(data);
        const language = values.defaultApplicationLanguage.split('-')[0];
        i18n.changeLanguage(language);
        localStorage.setItem('language', language);
        await queryClient.invalidateQueries({
          queryKey: [`current-theme`],
        });
      },
      onError: (error: DefaultError) => {
        onErrorShowAllErrorsToast(error);
      },
    });
  };

  useEffect(() => {
    if (getAppSettings.data) {
      setApplicationSettings(getAppSettings.data);
    }
  }, [getAppSettings.data]);

  return (
    <Form.ApplicationSettings
      status={{
        isLoading: getAppSettings.isLoading,
        displayMode: true,
      }}
      initialValues={
        getAppSettings.data
          ? middleware.settings.application.queryToForm(getAppSettings.data)
          : settingsInitialValues
      }
      i18nextPrefix='settings'
      onSubmit={onSubmit}
    />
  );
};

export default Application;
